import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import routes from './../utils/routes.json';

//Pages
import Home from './Home';

class Main extends Component {
	render() {
		return (
			<div style={{ flex: 1 }}>
				<BrowserRouter>
					<Routes>
						<Route path={routes.HOME} element={<Home />} />
					</Routes>
				</BrowserRouter>
			</div>
		);
	}
}

export default Main;